import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { LooseCurrencyPipe } from 'app/shared/pipes/loose-currency.pipe';
import { CurrencySymbolPipe } from './currency-symbol.pipe';
import { CustomDatePipe } from './custom-date.pipe';
import { FileSizePipe } from './file-size.pipe';
import { RedoneStatusPipe } from './redone-status.pipe';
import { SafePipe } from './safe.pipe';

@NgModule({
  exports: [CustomDatePipe, CurrencySymbolPipe, FileSizePipe, LooseCurrencyPipe, SafePipe, RedoneStatusPipe],
  imports: [CustomDatePipe, CurrencySymbolPipe, FileSizePipe, LooseCurrencyPipe, SafePipe, RedoneStatusPipe],
  providers: [DatePipe],
})
export class PipeModule {}
